const MetricClientIcon = (props) => (
	<svg
		width="24" height="24" viewBox="0 0 24 24"
		fill="currentColor"
		stroke="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17.6569 6.34313L12 8.46445L6.34315 6.34313L8.46447 12L6.34315 17.6568L12 15.5355L17.6569 17.6568L15.5355 12" />
	</svg>
)

export default MetricClientIcon